<template>
  <v-dialog v-model="dialogVisible"  class="responsive-x-padding">
    <v-card >
      <v-card-title>
        <v-text-field
          v-model="searchQuery"
          :label="t(searchcaption)"
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          hide-details
          clearable
          autofocus
     
          autocomplete="off"
          :style="{...sysTypo.sectionTypography.body}"
        />
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-list>
            <v-list-item
                v-for="(item, index) in searchResults"
                :key="item.id ?? item.pk ?? item.spageKeywords"
                :to="{ path: getlang === 'fr' ? item.spageLinkAddress_Fr : item.spageLinkAddress }"
                link
                @click="onSelect(item)"
                :class="`rowcolor${index}`"
                style="border-bottom: dotted; padding-top: 20px; padding-bottom: 20px;"
                :style="{...sysTypo.sectionTypography.body}"

            >
                <v-list-item-title
                    v-if="getlang === 'fr'"
                    v-html="item.spageKeywords_Fr"
                    class="wrap-text"
                    :style="{...sysTypo.sectionTypography.body}"
                />
                <v-list-item-title
                    v-else
                    v-html="item.spageKeywords"
                    class="wrap-text"
                    :style="{...sysTypo.sectionTypography.body}"
                />
            </v-list-item>
        </v-list>

        <div v-if="!loading && searchResults.length === 0" class="text-center mt-2" :style="{...sysTypo.sectionTypography.body}">
          {{ t('searchitems') }}
        </div>

        <div v-if="loading" class="text-center mt-2" :style="{...sysTypo.sectionTypography.body}">
          {{ t('loading') }}...
        </div>
      </v-card-text>

      <v-card-actions :style="{...sysTypo.sectionTypography.body}">
        <v-spacer />
        <v-btn text @click="dialogVisible = false"
            class="text-none formatbtn"
            style="height: 30px; font-size: 16px; color: white; margin-right: 40px;"
            min-width="100"
            variant="outlined"
            rounded
            :style="themeStore.sectionTheme.appBarBtnColor"
        >{{ t('closebtn') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch, onMounted, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import publicApi from '@/auth/publicApi'

import { useThemeStore } from "@/store/auth"
import { useSysTypo } from "@/store/useSysTypo";

const themeStore = useThemeStore()
const sysTypo = useSysTypo();

const { t } = useI18n()
const searchcaption = 'searchcaption'

// Props
const props = defineProps({
  modelValue: Boolean
})

const emit = defineEmits(['update:modelValue', 'select'])

// Local state
const dialogVisible = ref(props.modelValue)
const searchQuery = ref('')
const searchResults = ref([])
const loading = ref(false)
const debounceTimer = ref(null)
const abortCtrl = ref(null) // cancel in-flight requests
const getlang = ref('')

// Keep dialog in sync with parent
watch(() => props.modelValue, (val) => {
  dialogVisible.value = val
})
watch(dialogVisible, (val) => {
  emit('update:modelValue', val)
  if (!val) {
    // Clear results when closed
    searchQuery.value = ''
    searchResults.value = []
  }
})

// Debounced search
watch(searchQuery, (q) => {
  clearTimeout(debounceTimer.value)
  debounceTimer.value = setTimeout(() => {
    if (q.trim().length > 0) {
      fetchSearchResults(q)
    } else {
      searchResults.value = [] // clear if no query
    }
  }, 400)
})

async function fetchSearchResults(query) {
  if (!query) return // skip empty queries

  if (abortCtrl.value) {
    abortCtrl.value.abort()
  }
  abortCtrl.value = new AbortController()

  try {
    loading.value = true
    const { data } = await publicApi.get('/SearchPages', {
      params: { q: query },
      signal: abortCtrl.value.signal
    })
    searchResults.value = Array.isArray(data) ? data : []
  } catch (err) {
    if (err.name !== 'CanceledError' && !axios.isCancel?.(err)) {
      console.error('Search error:', err)
    }
  } finally {
    loading.value = false
  }
}

function selectItem(item) {
  emit('select', item) // emitting the whole object; change to item.spagekeywords if you only need text
  dialogVisible.value = false
}

onMounted(() => {
  getlang.value = localStorage.getItem('locale') || 'en'
})

function onSelect(item) {
  dialogVisible.value = false    // close the dialog
  emit('select', item)           // optional: emit to parent
  // Navigation will still happen because v-list-item with `link` + `:to` handles it
}
</script>

<style scoped>

.wrap-text {
  white-space: normal !important;       /* allow line breaks */
  word-break: break-word !important;    /* break long words if needed */
  overflow-wrap: anywhere !important;   /* ensures wrapping in tight spaces */
  display: block;                        /* override flex child behavior */
}
.responsive-x-padding {
  padding-left: 10px;
  padding-right: 10px;
 
}

@media (min-width: 600px) { /* sm */
  .responsive-x-padding {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (min-width: 960px) { /* md */
  .responsive-x-padding {
    padding-left: 100px;
    padding-right: 100px;
  }
}

@media (min-width: 1920px) { /* xl */
  .responsive-x-padding {
    padding-left: 200px;
    padding-right: 200px;
  }
}

</style>
